import React, { useState } from "react";
import { Badge, Button, Col, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../../services/PrivateApiService";
import { FaSearch } from "react-icons/fa";

/**
 * 
 * @param {setSelectedInvoices} props list setter
 * @param {setStage} props string setter
 * @param {error} props string setter for api errors
 */
const PoolrechnungTicketStage = (props) => {

    const API = new PrivateApi();
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [poolrechnungNotFound, setPoolrechnungNotFound] = useState(false);
    const [invoiceBadgeHover, setInvoiceBadgeHover] = useState(false);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [invoiceNum, setInvoiceNum] = useState("");
    const [invoiceError, setInvoiceError] = useState("Nicht gefunden...");


    // remove poolrechnung from selected list
    const removeSelectedPoolrechnungHandler = (id) => {
        var tempList = selectedInvoices.filter(si => si.id !== id);
        setSelectedInvoices(tempList);
    }

    // on search field enter pressed 
    const invoiceSearchFieldEnterHandler = (event) => {
        if (event.key === "Enter") {
            searchPoolrechnungHandler();
        }
    }

    // invoices search for poolrechnung
    const searchPoolrechnungHandler = () => {
        setPoolrechnungNotFound(false);
        var tempList = [...selectedInvoices];
        var index = tempList.findIndex(i => i.x_rechnungsnummer === invoiceNum);
        if (index === -1) {
            setInvoiceLoading(true);
            API.get_Poolrechnung_by_rechnungsnummer(invoiceNum)
                .then(res => {
                    let data = res.data;
                    tempList.push(data);
                    setSelectedInvoices(tempList);
                    setInvoiceLoading(false);
                    setInvoiceNum("");
                })
                .catch(err => {
                    //setApiError(err.response.detail);
                    setInvoiceLoading(false);
                    setInvoiceError("Nicht gefunden...")
                    setPoolrechnungNotFound(true);
                });
        } else {
            setInvoiceError("Rechnung ist bereits ausgewählt.");
            setPoolrechnungNotFound(true);
        }
    }


    return (
        <>
            <h5>Geben Sie die Rechnungsnummer ein</h5>
            <p>Um Ihnen weiterzuhelfen benötigen wir die Rechnungsnummer</p>
            <Row className="mt-5" hidden={selectedInvoices.length === 0}>
                <Col xs="12" className="text-center">
                    <p>Ausgewählte ENERGO Rechnungen:</p>
                    {selectedInvoices !== null && selectedInvoices.length > 0 ?
                        selectedInvoices.map(i => (
                            <Badge
                                onClick={() => removeSelectedPoolrechnungHandler(i.id)}
                                onMouseEnter={() => setInvoiceBadgeHover(true)}
                                onMouseLeave={() => setInvoiceBadgeHover(false)}
                                key={i.id}
                                id={`badge-${i.id}`}
                                style={{ marginRight: "5px", cursor: "pointer" }}
                                bg="energo"
                                className="animate-slide-left"
                            >{i.x_rechnungsart} {i.x_rechnungsnummer} {invoiceBadgeHover ? "X" : null}</Badge>
                        ))
                        : null}
                </Col>
            </Row>
            <Row className="mt-5 justify-content-center">
                <Col xs="12" md="12" xl="8" className="text-center">
                    <InputGroup>
                        <Form.Control disabled={invoiceLoading} onKeyDown={(e) => invoiceSearchFieldEnterHandler(e)} onChange={e => setInvoiceNum(e.target.value)} value={invoiceNum} placeholder="Rechnungsnummer" />
                        <Button disabled={invoiceLoading} onClick={() => searchPoolrechnungHandler()}><FaSearch /></Button>
                    </InputGroup>
                    <br />
                    <p hidden={!poolrechnungNotFound} className="text-danger">{invoiceError}</p>
                </Col>
            </Row>
            <Row className="mt-5 text-center" hidden={!invoiceLoading}>
                <Col xs="12">
                    <Spinner animation="grow" className="text-energo" /> &nbsp;
                    <Spinner animation="grow" className="text-energo" /> &nbsp;
                    <Spinner animation="grow" className="text-energo" />
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" className="text-end">
                    <Button onClick={() => props.setStage("Rechnung (ENERGO, Lieferantenrechnung)")} variant="warning">Zurück</Button> &nbsp;
                    <Button onClick={() => {props.setSelectedInvoices(selectedInvoices); props.setStage('body')}} hidden={selectedInvoices.length === 0} className="btn-energo">Weiter</Button>
                </Col>
            </Row>
        </>
    )
}

export default PoolrechnungTicketStage;